import axios from 'axios'

export default {
    namespaced: true,
    state: {
        titleChart: 'Vencidos',
        data_loaded: false,
        dashboardData: {
            countEx: 0,
            countExActive: false,
            count30: 0,
            count30Active: false,
            count60: 0,
            count60Active: false,
            count90: 0,
            count90Active: false,
            countExecuted: 0,
            countExecutedActive: false,
            countUpdate: 0,
            countUpdateActive: false,
            countRadar: 0,
            countRadarActive: false,
            countAll: 0,
            countAllActive: false,
            scheduleMonthAgenda: [],
            validShowGridType: 'compliance',
            gridDataComplianceFilterRadar: [],
            gridDataCompliance: [],
            gridDataComplianceTmp: [],
        },
        pieChartData: {
          total: 0,
          data: []
        },
    },
    getters: {
        isDataLoaded(state) {
            return state.data_loaded;
        },
        getDashboardData(state) {
            return state.dashboardData;
        },
        getPieChartData(state){
            return state.pieChartData;
        },
        getGridDataCompliance(state){
            return state.dashboardData.gridDataCompliance;
        },
        getGridDataComplianceTmp(state){
            return state.dashboardData.gridDataComplianceTmp;
        },
        getGridDataComplianceFilterRadar(state){
            return state.dashboardData.gridDataComplianceFilterRadar;
        },
        getTitleChart(state){
            return state.titleChart;
        }
    },
    mutations: {
        setTopics(state, data_loaded) {
            state.data_loaded = data_loaded;
        },
        setTitleChart(state, value){
            state.titleChart = value;
        },
        setPieChartData(state, data) {
            state.pieChartData = data;
        },
        resetDashboardData(state){
            state.validShowGridType = 'compliance';
            state.gridDataComplianceFilterRadar = [];
            state.gridDataCompliance = [];
            state.gridDataComplianceTmp = [];
            state.dashboardData.countExActive = false;
            state.dashboardData.count30Active = false;
            state.dashboardData.count60Active = false;
            state.dashboardData.countExecutedActive = false;
            state.dashboardData.countUpdateActive = false;
            state.dashboardData.countRadarActive = false;
            state.dashboardData.countAllActive = false;
        },
        setDashboardData(state, data){
           state.dashboardData = data;
        },
        setDataLoaded(state, value){
          state.data_loaded = value;
        }
    },
    actions: {
        async initDashboard(context) {
            let title_chart = '';
            title_chart = 'Vencidos';
            let dashboardDataTemp = {...context.getters['getDashboardData']}
            await axios.post('/auth/compliance/getComplianceDashboard', {
                global_filters: localStorage.getItem('global_filters'),
                filter: 'countEx',
                filterSchedule: false,
                is_structuring: true,
            }).then(response => {

                if (response.data.gridDataCompliance.length) {
                    dashboardDataTemp.countExActive = true;
                }

                dashboardDataTemp.gridDataCompliance = response.data.gridDataCompliance;
                dashboardDataTemp.gridDataComplianceTmp = response.data.gridDataCompliance;

                context.dispatch('setQuantities', {dashboardDataTemp: dashboardDataTemp, data: response.data});

                context.commit('setDashboardData', dashboardDataTemp);
                context.dispatch('formatDataPieChart', response.data.gridDataCompliance);
                context.commit('setDataLoaded', true);
                let total = context.getters['getPieChartData'].total;
                title_chart += " (" + total + ")";

            }).finally(()=> {
                Vue.prototype.$eventHub.$emit('onHideSpinner');
            });
        },
        setQuantities(context, {dashboardDataTemp, data}){
            dashboardDataTemp.scheduleMonthAgenda = data.scheduleMonthAgenda;
            dashboardDataTemp.countEx = data.countEx;
            dashboardDataTemp.count30 = data.count30;
            dashboardDataTemp.count60 = data.count60;
            dashboardDataTemp.countExecuted = data.countExecuted;
            dashboardDataTemp.countUpdate = data.countUpdate;
            dashboardDataTemp.countRadar = data.countRadar;
            dashboardDataTemp.countAll = data.countAll;
        },
        filterDashboardByDays(context, data){

            let title_chart = '';
            let dashboardDataTemp = {...context.getters['getDashboardData']}
            dashboardDataTemp.validShowGridType = 'compliance';

            switch (data.args) {
                case 'countEx':
                    title_chart = 'Vencidos';
                    dashboardDataTemp.countExActive = true;
                    break;
                case 'count30':
                    title_chart = 'A 30 días';
                    dashboardDataTemp.count30Active = true;
                    break;
                case 'count60':
                    title_chart = 'A 60 días';
                    dashboardDataTemp.count60Active = true;
                    break;
                case 'count90':
                    title_chart = 'A 90 días';
                    dashboardDataTemp.count90Active = true;
                    break;
                case 'executed':
                    title_chart = 'Ejecutados';
                    dashboardDataTemp.countExecutedActive = true;
                    break;
                case 'all':
                    this.titleChart = 'Todos ';
                    dashboardDataTemp.countAllActive = true;
                    break;
            }
            axios.post('/auth/compliance/getComplianceDashboardFilter', {
                global_filters: localStorage.getItem('global_filters'),
                filter: data.args,
                is_structuring : true,
            }).then(response => {
                dashboardDataTemp.gridDataCompliance = response.data;
                dashboardDataTemp.gridDataComplianceTmp = response.data;
                dashboardDataTemp.currentFilter = data.args;
                console.log('args', data.args);

                context.dispatch('formatDataPieChart', response.data);
                context.commit('setDataLoaded', true);

                let total = context.getters['getPieChartData'].total;
                title_chart += " (" + total + ")";

            }).finally(()=> {
                context.commit('setTitleChart', title_chart);
                context.commit('setDashboardData', dashboardDataTemp);
                Vue.prototype.$eventHub.$emit('onHideSpinner');
            });
        },
        filterByUpdate(context){

            let dashboardDataTemp = {...context.getters['getDashboardData']}
            let title_chart = '';
            title_chart = 'Actualizaciones';

            dashboardDataTemp.validShowGridType = 'update';
            dashboardDataTemp.countUpdateActive = true;

            axios.post('/auth/compliance/getComplianceDashboardFilterUpdate', {
                global_filters: localStorage.getItem('global_filters'),
            }).then(response => {
                let array_concated = []

                response.data.forEach(element => {
                 array_concated =  array_concated.concat(element);
                });

                dashboardDataTemp.gridDataCompliance =  array_concated;
                dashboardDataTemp.gridDataComplianceTmp =  array_concated;
                title_chart = 'Actualizaciones';

                context.commit('setDataLoaded', true);
                context.dispatch('formatDataPieChart', response.data);
                let total = context.getters['getPieChartData'].total;
                title_chart += " (" + total + ")";

            }).finally(()=> {
                context.commit('setTitleChart', title_chart);
                context.commit('setDashboardData', dashboardDataTemp);
                Vue.prototype.$eventHub.$emit('onHideSpinner');
            });

        },
        filterByRadar(context){

            let dashboardDataTemp = {...context.getters['getDashboardData']}
            let title_chart = '';
            title_chart = 'Radar';

            dashboardDataTemp.validShowGridType = 'radar';
            dashboardDataTemp.countRadarActive = true;

            axios.post('/auth/compliance/getComplianceDashboardFilterRadar', {
                global_filters: localStorage.getItem('global_filters'),
            }).then(response => {
                dashboardDataTemp.gridDataComplianceFilterRadar = response.data;
                dashboardDataTemp.gridDataComplianceTmp = response.data;

                context.dispatch('formatDataPieChart', response.data);
                context.commit('setDataLoaded', true);
                let total = context.getters['getPieChartData'].total;
                title_chart += " (" + total + ")";

            }).finally(()=> {
                context.commit('setTitleChart', title_chart);
                context.commit('setDashboardData', dashboardDataTemp);
                Vue.prototype.$eventHub.$emit('onHideSpinner');
            });

        },
        formatDataPieChart(context, data) {
            let dataTmp = [];
            let dataTmp2 = [];
            let total = 0;

            data.forEach(function (value) {
                if (dataTmp[value.proceso_id] == undefined) {
                    dataTmp[value.proceso_id] = {x: value.nombre_proceso, y: 0, text: 0, proceso_id: value.proceso_id};
                }

                dataTmp[value.proceso_id].y += 1;
            });
            total = data.length;
            dataTmp.forEach(function (value) {
                value.text = ((value.y / total) * 100).toFixed(2);
                value.text += '%';
                dataTmp2.push(value);
            });
            context.commit('setPieChartData', {data: dataTmp2, total: total});
        },
        updateGridDataCompliance(context, data){
            let dashboardDataTemp = {...context.getters['getDashboardData']};
            dashboardDataTemp.gridDataCompliance = data;
            context.commit('setDashboardData', dashboardDataTemp);
        },
        updateGridDataComplianceTemp(context, data){
            let dashboardDataTemp = {...context.getters['getDashboardData']};
            dashboardDataTemp.gridDataComplianceTmp = data;
            context.commit('setDashboardData', dashboardDataTemp);
        },
        clearDashboardData(context){
            context.commit('resetDashboardData');
        },
        changeIsDataLoaded(context, value){
            context.commit('setDataLoaded', value);
        }
    }
}